import { render, staticRenderFns } from "./ClientDetail.vue?vue&type=template&id=7e2bcc46&"
import script from "./ClientDetail.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ClientDetail.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ClientDetail.vue?vue&type=style&index=0&id=7e2bcc46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports